<template>
  <div>
    <b-row>
      <h2>{{ $t("checklist.sidebar.FilledForms") }}</h2>
    </b-row>
    <!-- <pre class="language-json"><code>{{ tableFilters  }}</code></pre> -->
    <b-row class="mb-3 ml-0">
      <!-- <b-button size="sm" @click="exportCsv">Exportar CSV</b-button> -->
      <checklist-filled-export
        :fields="fields"
        :table-filters="tableFilters"
        :pagination-per-page="tablePerPage"
      >
      </checklist-filled-export>
      <checklist-export-pdf-progress-modal
        class="ml-2"
        :fields="fields"
        :table-filters="tableFilters"
        :pagination-per-page="tablePerPage"
      ></checklist-export-pdf-progress-modal>
    </b-row>
    <!-- <pre class="language-json"><code>{{ filterApplied  }}</code></pre> -->

    <div v-if="!isLoadingFilters">
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="tablePerPage"
        current-page="0"
        :filter="tableFilters"
        @context-changed="contextChanged"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
          </div>
        </template>
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.key"
              class="vertical-align"
            >
              <div v-if="field.type == 'actions'">
                <b-form-group
                  :label="$t('geral.saveFilters')"
                  label-for="saveFilter"
                  class="labelSaveFilter"
                >
                  <b-form-checkbox
                    class="checkboxSaveFilter"
                    id="saveFilter"
                    v-model="filterApplied.saveFilter"
                  ></b-form-checkbox>
                </b-form-group>
                <b-button
                  size="sm"
                  class="btn-checklist cleanFilters"
                  @click="cleanFilters"
                >
                  {{ $t("geral.cleanFilters") }}
                </b-button>
              </div>
              <div v-else-if="field.type == 'date'">
                <base-filter-date
                  ref="baseFilterDate"
                  :dateFill.sync="tableFilters.dateFill"
                  :dateBegin.sync="tableFilters.dateBegin"
                  :dateEnd.sync="tableFilters.dateEnd"
                  :filterName.sync="field.label"
                  :optionFilterDate.sync="optionFilterDate"
                  :filterDates="filterApplied.filterDateApplied"
                  v-model="tableFilters[field.key]"
                ></base-filter-date>
              </div>
              <div v-else>
                <b-form-input
                  v-model="tableFilters[field.key]"
                  :placeholder="'Buscar por ' + field.label"
                  debounce="3000"
                />
              </div>
            </b-th>
          </b-tr>
        </template>

        <template v-slot:cell(actions)="data">
          <b-col class="buttons">
            <router-link
              :to="'/checklist/form/filled/details/' + data.item.checklistId"
            >
              <b-button size="sm">{{ $t("geral.detalhes") }}</b-button>
            </router-link>
          </b-col>
        </template>
      </b-table>
      <table-pagination-range
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
        @homePage="homePage"
        @prevPage="prevPage"
        @nextPage="nextPage"
      >
      </table-pagination-range>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    BaseFilterDate: () => import("@/components_rms/base/BaseFilterDate.vue"),
    ChecklistFilledExport: () =>
      import("@/pagesRms/checklist/checklist/ChecklistFilledExport.vue"),
    ChecklistExportPdfProgressModal: () =>
      import(
        "@/pagesRms/checklist/checklist/ChecklistExportPdfProgressModal.vue"
      ),
    TablePaginationRange: () =>
      import("@/components_rms/base/TablePaginationRange.vue"),
  },
  data: function () {
    return {
      apiFilter: {
        currentPage: 1,
        perPage: 10,
        checklistId: null,
        formName: null,
        formSearchKey: null,
        dateFill: null,
        fillDateBegin: null,
        fillDateEnd: null,
        fillUserName: null,
        checklistStatus: null,
      },
      isBusy: false,
      isLoadingFilters: true,
      allFields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          type: "actions",
          tdClass: "checklist-filled-table-col-buttons",
        },
        {
          key: "checklistId",
          filterKey: "checklistId",
          sortable: false,
          label: "Checklist",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "formSearchKey",
          filterKey: "formSearchKey",
          sortable: true,
          label: "Chave de busca",
        },
        {
          key: "formName",
          filterKey: "formName",
          sortable: true,
          label: "Formulário",
        },
        {
          key: "dateFill",
          filterKeyBegin: "dateBegin",
          filterKeyEnd: "dateEnd",
          filterType: "dateRange",
          sortable: true,
          label: "Data preenchimento",
          type: "date",
          formatter: (value, key, item) => {
            let date = new Date(item.dateFill);
            return date.toLocaleString();
          },
        },

        {
          key: "checklistStatus",
          filterKey: "checklistStatus",
          sortable: true,
          label: "Status",
        },
        {
          key: "userFillName",
          filterKey: "userFillName",
          sortable: true,
          label: "Responsável preenchimento",
        },
      ],
      tableFilters: {
        checklistId: "",
        formName: "",
        formSearchKey: "",
        dateFill: "",
        checklistStatus: "",
        userFillName: "",
        dateEnd: "",
        dateBegin: "",
        formId: 0,
      },
      paginationEnd: "",
      paginationEndList: [],
      tableItems: [],
      optionFilterDate: 0,
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150, 500, 1000],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      filterApplied: {
        pageUrl: "",
        saveFilter: true,
        appliedFilters: "",
      },
    };
  },
  computed: {
    fields() {
      if (!this.hideFillDateColumn) return this.allFields;
      return this.allFields.filter((field) => field.key != "dateFill");
    },
    hideFillDateColumn() {
      const agBrasilDocument = "17339465000174";
      const companyDocument = String(
        this.$store.getters.companyDocument || ""
      ).replace(/\D/g, "");

      return companyDocument == agBrasilDocument;
    },
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  created() {
    this.getSaveFilters();
  },
  methods: {
    clearHiddenFilters() {
      if (!this.hideFillDateColumn) return;

      this.tableFilters.dateFill = "";
      this.tableFilters.dateBegin = "";
      this.tableFilters.dateEnd = "";
    },
    async saveFilters() {
      this.filterApplied.pageUrl = window.location.href;
      this.clearHiddenFilters();
      let stringFilter = JSON.stringify(this.tableFilters);
      if (this.filterApplied.saveFilter == true) {
        this.filterApplied.appliedFilters = stringFilter;
        this.$apiChecklist
          .post("/fitlerApplied/saveFilters/", this.filterApplied)
          .then((response) => {
            let model = JSON.parse(response.data.appliedFilters);
            this.tableFilters = model;
            this.filterApplied.appliedFilters = response.data.appliedFilters;
          });
      }
    },
    async getSaveFilters() {
      this.filterApplied.pageUrl = window.location.href;
      this.$apiChecklist
        .post("/fitlerApplied/GetSaveFilter/", this.filterApplied)
        .then((response) => {
          if (response.data) {
            let model = JSON.parse(response.data.appliedFilters);
            this.tableFilters = model;
            this.filterApplied.appliedFilters = response.data.appliedFilters;
            this.filterApplied = response.data;
          }
          this.clearHiddenFilters();
          this.isLoadingFilters = false;
          this.$forceUpdate();
          this.myProviderCount();
        });
    },
    myProvider(ctx) {
      if (this.isLoadingFilters) {
        this.isBusy = false;
        this.tableRowCount = 0;
        return [];
      }

      this.isBusy = true;
      this.clearHiddenFilters();
      this.apiFilter = {
        currentPage: 1,
        perPage: this.tablePerPage,
        checklistId: this.tableFilters.checklistId,
        formName: this.tableFilters.formName,
        formSearchKey: this.tableFilters.formSearchKey,
        dateFill: this.tableFilters.dateFill,
        fillDateBegin: this.tableFilters.dateBegin,
        fillDateEnd: this.tableFilters.dateEnd,
        fillUserName: this.tableFilters.userFillName,
        checklistStatus: this.tableFilters.checklistStatus,
        formId: 0,
        paginationBegin: "",
        paginationEnd: this.paginationEnd,
      };

      return this.$apiChecklist
        .post("/checklist/filled/pagination/list/", this.apiFilter)
        .then((response) => {
          const items = response.data;
          this.isBusy = false;
          this.tableItems = items;
          this.saveFilters();
          return items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableItems = [];
            return [];
          }
        });
    },
    myProviderCount() {
      this.clearHiddenFilters();
      this.apiFilter = {
        currentPage: 1,
        perPage: this.tablePerPage,
        checklistId: this.tableFilters.checklistId,
        formName: this.tableFilters.formName,
        formSearchKey: this.tableFilters.formSearchKey,
        dateFill: this.tableFilters.dateFill,
        fillDateBegin: this.tableFilters.dateBegin,
        fillDateEnd: this.tableFilters.dateEnd,
        fillUserName: this.tableFilters.userFillName,
        checklistStatus: this.tableFilters.checklistStatus,
        formId: 0,
      };

      return this.$apiChecklist
        .post("/checklist/filled/pagination/count/", this.apiFilter)
        .then((response) => {
          this.tableRowCount = response.data;
          return response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.tableRowCount = 0;
            return [];
          }
        });
    },
    exportCsv() {
      this.$apiChecklist
        .request({
          url: "/checklist/exporttocsv/",
          method: "POST",
          data: this.apiFilter,
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    cleanFilters() {
      this.tableFilters.dateEnd = "";
      this.tableFilters.dateBegin = "";
      this.tableFilters.checklistId = "";
      this.tableFilters.formName = "";
      this.tableFilters.formSearchKey = "";
      this.tableFilters.dateFill = "";
      this.tableFilters.checklistStatus = "";
      this.tableFilters.userFillName = "";
      this.tableFilters.formId = 0;

      this.filterApplied.filterDateApplied.forEach((filter) => {
        filter.optionFilterDate = 0;
        this.optionFilterDate = 0;
      });
      this.saveFilters();
    },
    refreshModel() {
      this.tableFilters.dateEnd = "";
      this.tableFilters.dateBegin = "";
      this.tableFilters.checklistId = "";
      this.tableFilters.formName = "";
      this.tableFilters.formSearchKey = "";
      this.tableFilters.dateFill = "";
      this.tableFilters.checklistStatus = "";
      this.tableFilters.userFillName = "";
    },
    homePage(currentPage) {
      this.tableCurrentPage = 1;
      this.paginationEnd = "";
      this.paginationEndList = [];
      this.$refs.table.refresh();
    },
    nextPage(currentPage) {
      if (this.tableItems) {
        if (this.tableItems.length > 0) {
          let paginationEnd =
            this.tableItems[this.tableItems.length - 1].dateFill;
          this.paginationEnd = paginationEnd;
          this.paginationEndList.push(paginationEnd);
        }
      }
      this.$refs.table.refresh();
    },
    prevPage(currentPage) {
      if (this.paginationEndList.length > 0) {
        this.paginationEndList.splice(this.paginationEndList.length - 1, 1);
      }
      if (this.paginationEndList.length > 0) {
        let paginationEnd =
          this.paginationEndList[this.paginationEndList.length - 1];
        this.paginationEnd = paginationEnd;
        this.$refs.table.refresh();
      } else {
        this.paginationEnd = "";
        this.$refs.table.refresh();
      }
    },
    contextChanged() {
      this.tableCurrentPage = 1;
      this.paginationEnd = "";
      this.paginationEndList = [];
      this.myProviderCount();
    },
  },
};
</script>

<style>
.checklist-filled-table-col-buttons {
  width: 130px;
}
.dateFilter {
  margin-bottom: 10px;
}
.vertical-align {
  vertical-align: bottom !important;
}
</style>
<style scoped>
.checkboxSaveFilter {
  margin-left: 105px;
  margin-top: -28px;
}
</style>
